"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevenLabsEnvironment = void 0;
exports.ElevenLabsEnvironment = {
    Production: {
        base: "https://api.elevenlabs.io",
        wss: "wss://api.elevenlabs.io",
    },
    ProductionUs: {
        base: "https://api.us.elevenlabs.io",
        wss: "wss://api.elevenlabs.io",
    },
    ProductionEu: {
        base: "https://api.eu.residency.elevenlabs.io",
        wss: "wss://api.elevenlabs.io",
    },
};
